import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import EmergencyContactForm from '../../../Components/Forms/EmergencyContactForm/EmergencyContactForm';
import { guestEmergencyContact } from '../../../services/adapters/guest';

const AdminEditEmergencyContact = ({ guest, event, onChange, dispatch, ...rest }) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const currentFormData = guestEmergencyContact(guest);

    const [form, setForm] = useState({
        first_name: '',
        last_name: '',
        relationship: '',
        phone: '',
    });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {

        adminHttp
            .put(`/guests/${guest.id}/emergency-contact`, form)
            .then(res => {
                setError(null);
                setShow(false);
                onChange();
            })
            .catch((error) => {
                setError(error.response?.data);
            });
    };

    useEffect(() => {
        setForm({ ...form, ...currentFormData });
    }, [])

    return (
        <>
            <button {...rest} onClick={handleShow}>Edit Emergency Contact</button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Personal Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <EmergencyContactForm values={form} errors={error?.errors} onChange={setForm} />
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEditEmergencyContact);
